import { getData } from './http';

export function getMarkers(params) {
    return getData(`/api/hotels/maps/getmarkers${params}`, { cache: true });
}
